<template>
  <BaseCard :width="width">
    <div class="folha" v-if="dadosEvento != null">
      <div slot="header">
        <h3>Veículo</h3>
        <br />
      </div>
      <div>
        <table class="table table-bordered" v-if="dadosEvento.dadosVeiculo">
          <tr v-if="dadosEvento.dadosVeiculo.isZero">
            <th class="uppercase">Zero KM</th>
            <td>
              NF: {{ dadosEvento.dadosVeiculo.nf }}
              <Br />
              Data:{{ dadosEvento.dadosVeiculo.dataNf | formatDate }}
              <br />
              valor: {{ dadosEvento.dadosVeiculo.valorNf | currency }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Grupo</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.grupo }}
            </td>
          </tr>
          <tr v-if="dadosEvento.dadosVeiculo.veiculoMarca">
            <th class="uppercase">Marca</th>
            <td>{{ dadosEvento.dadosVeiculo.veiculoMarca }}</td>
          </tr>
          <tr v-if="dadosEvento.dadosVeiculo.veiculoModelo">
            <th class="uppercase">Modelo</th>
            <td>{{ dadosEvento.dadosVeiculo.veiculoModelo }}</td>
          </tr>
          <tr v-if="dadosEvento.dadosVeiculo.anoFabricacao">
            <th class="uppercase">Ano</th>
            <td>
              {{ dadosEvento.dadosVeiculo.anoFabricacao }} /
              {{ dadosEvento.dadosVeiculo.anoModelo }}
            </td>
          </tr>
          <tr v-if="dadosEvento.dadosVeiculo.placa">
            <th class="uppercase">Placa</th>
            <td>
              {{ dadosEvento.dadosVeiculo.placa }}
              <router-link
                v-if="dadosEvento.dadosCliente"
                target="_blank"
                :to="`/DetalheAssociado/${dadosEvento.dadosCliente.idProspect}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
          </tr>

          <tr v-if="dadosEvento.dadosVeiculo.chassi">
            <th class="uppercase">Chassi</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.chassi }}
            </td>
          </tr>

          <tr v-if="dadosEvento.dadosVeiculo.codigoFipe">
            <th class="uppercase">Codigo Fipe</th>
            <td>{{ dadosEvento.dadosVeiculo.codigoFipe }}</td>
          </tr>
          <tr>
            <th class="uppercase">Status</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.status }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Data de Cadastro</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.dataCadastro | formatDate }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Renavam</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.renavam }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Cambio</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.cambio}}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Cor</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.cor }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Franquia</th>
            <td style="text-transform: uppercase">
              {{ dadosEvento.dadosVeiculo.cotaParticipacao }}%
            </td>
          </tr>
        </table>
      </div>
    </div>
  </BaseCard>
</template>

<script>
import BaseCard from './BaseCard.vue';

export default {
  props: {
    dadosEvento: {
      type: Object,
    },
    width: {
      type: Number,
      default: 4,
    },
  },
  components: {
    BaseCard,
  },
};
</script>
